import { Box, BoxProps } from "@mui/material";
import { ReactNode } from "react";
import { DropzoneOptions, useDropzone } from "react-dropzone";

interface FileUploaderWrapperProps extends BoxProps {
  children: ReactNode;
  dropzoneOptions: DropzoneOptions;
}

export function FileUploaderWrapper({ children, dropzoneOptions = {}, ...props }: FileUploaderWrapperProps) {
  const { getRootProps, getInputProps } = useDropzone(dropzoneOptions);

  return (
    <Box {...getRootProps()} {...props}>
      <input {...getInputProps()} />
      {children}
    </Box>
  );
}
